import React from 'react';
import _ from 'lodash';

import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';

import Field from '@common/components/validation/field.validation';
import { TimePicker } from '@progress/kendo-react-dateinputs';
import DateFormat from '@common/components/formats/date.format';

import FocusHelper from '@common/helpers/focus.helper';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setFocus();
  }

  setFocus() {
    const { name, setFocus } = this.props;
    if (setFocus) FocusHelper.focus(name);
  }

  renderComponent() {
    const { props } = this;
    const { Label, Tooltip, Obrigatorio, Desabilitado, Placeholder,Formato ,name } = props;

    return (
      <Field {...props}>
        {({ value, hasError, onChangeAsync, onBlur }) => {
          return (
            <LabeledInput {...props}>
              <TimePicker
                name={name}
                title={Tooltip || Label}
                className={`${hasError ? 'span-input-invalid' : ''}`}
                value={value}
                format={Formato ? Formato : "hh:mm a"}
                disabled={Desabilitado}
                required={Obrigatorio}
                onChange={onChangeAsync}
                onBlur={onBlur}
                formatPlaceholder={{ hour: '__', minute: '__', second: '__' }}
                placeholder={Placeholder || Label}
              />
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <DateFormat value={field.value} onlyTime={true} />
            </LabeledInput>
          );
        }}
      </Field>
    );
  }
}

export default DDadosComponent;
